import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        d="M10.5 6.75H8.25V4.5a.75.75 0 1 0-1.5 0v3c0 .415.336.75.75.75h3a.75.75 0 1 0 0-1.5m-3 6.75c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6M7.5 0C3.364 0 0 3.365 0 7.5 0 11.636 3.365 15 7.5 15c4.136 0 7.5-3.364 7.5-7.5S11.636 0 7.5 0"
        // fill="#A4B1C2"
        fillRule="nonzero"
      />
    </svg>
  )
}
const TimeIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
TimeIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: '#A4B1C2',
}
// 参数类型
TimeIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default TimeIcon
